<template>
	<div class="app-box">
		<el-image :src="require('@images/icon/line_left.png')"></el-image>
		<span class="app-text" v-if="$slots.default"><slot></slot></span>
		<el-image :src="require('@images/icon/line_right.png')"></el-image>
	</div>
</template>
<script lang="js">
export default {
	name: "LineTitle"
};
</script>

<style lang="scss" scoped>
.app-text {
  margin: 0 19px;
  font-size: 18px;
  font-weight: bolder;
}
.el-image {
  padding-top: 15px;
}
.app-box {
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
